module.exports = "<div style=\"margin-top: 0px;\">\n  <router-outlet></router-outlet>\n</div>\n"